export const decimalNumberRegex =
    /^([1-9]\d{0,15}\.?\d{1,15}|\d\.\d{1,15}|[1-9]\d{0,15}\.|0\.|\d)$/;

export const receiptUniqueReference = /^(?=.{1,25}$)/;
